const checkPricesConstants = {
	CLEAR_STEP_STORE : 'CLEAR_STEP_STORE',
	CHECK_DATA_ENTRY : {
		FAILURE : 'CHECK_DATA_ENTRY_FAILURE',
		REQUEST : 'CHECK_DATA_ENTRY_REQUEST',
		SUCCESS : 'CHECK_DATA_ENTRY_SUCCESS'
	},
	COMPARE_PRICES: {
		FAILURE : 'COMPARE_PRICES_FAILURE',
		REQUEST : 'COMPARE_PRICES_REQUEST',
		SUCCESS : 'COMPARE_PRICES_SUCCESS'
	},
	CREATE_PERIOD_ACCESS_FOR_REORGS: {
		FAILURE : 'CREATE_PERIOD_ACCESS_FOR_REORGS_FAILURE',
		REQUEST : 'CREATE_PERIOD_ACCESS_FOR_REORGS_REQUEST',
		SUCCESS : 'CREATE_PERIOD_ACCESS_FOR_REORGS_SUCCESS'
	},
	GET_PAGED_REORGS_PERIOD_ACCESS: {
		FAILURE : 'GET_PAGED_REORGS_PERIOD_ACCESS_FAILURE',
		REQUEST : 'GET_PAGED_REORGS_PERIOD_ACCESS_REQUEST',
		SUCCESS : 'GET_PAGED_REORGS_PERIOD_ACCESS_SUCCESS'
	},
	GET_PAGED_REORG_CONSTRACTION_MATERIALS_PERIOD_ACCESS_ALLOWED: {
		FAILURE : 'GET_PAGED_REORG_CONSTRACTION_MATERIALS_PERIOD_ACCESS_ALLOWED_FAILURE',
		REQUEST : 'GET_PAGED_REORG_CONSTRACTION_MATERIALS_PERIOD_ACCESS_ALLOWED_REQUEST',
		SUCCESS : 'GET_PAGED_REORG_CONSTRACTION_MATERIALS_PERIOD_ACCESS_ALLOWED_SUCCESS'
	},
	GET_PAGED_REORG_CONSTRACTION_MATERIALS_PERIOD_ACCESS_NOT_ALLOWED: {
		FAILURE : 'GET_PAGED_REORG_CONSTRACTION_MATERIALS_PERIOD_ACCESS_NOT_ALLOWED_FAILURE',
		REQUEST : 'GET_PAGED_REORG_CONSTRACTION_MATERIALS_PERIOD_ACCESS_NOT_ALLOWED_REQUEST',
		SUCCESS : 'GET_PAGED_REORG_CONSTRACTION_MATERIALS_PERIOD_ACCESS_NOT_ALLOWED_SUCCESS'
	},
	ALLOW_PERIOD_ACCESS_FOR_ALL: {
		FAILURE : 'ALLOW_PERIOD_ACCESS_FOR_ALL_FAILURE',
		REQUEST : 'ALLOW_PERIOD_ACCESS_FOR_ALL_REQUEST',
		SUCCESS : 'ALLOW_PERIOD_ACCESS_FOR_ALL_SUCCESS'
	},
	ALLOW_PERIOD_ACCESS_FOR_REORGS: {
		FAILURE : 'ALLOW_PERIOD_ACCESS_FOR_REORGS_FAILURE',
		REQUEST : 'ALLOW_PERIOD_ACCESS_FOR_REORGS_REQUEST',
		SUCCESS : 'ALLOW_PERIOD_ACCESS_FOR_REORGS_SUCCESS'
	},
	ALLOW_PERIOD_ACCESS_FOR_REORG_MATERIALS: {
		FAILURE : 'ALLOW_PERIOD_ACCESS_FOR_REORG_MATERIALS_FAILURE',
		REQUEST : 'ALLOW_PERIOD_ACCESS_FOR_REORG_MATERIALS_REQUEST',
		SUCCESS : 'ALLOW_PERIOD_ACCESS_FOR_REORG_MATERIALS_SUCCESS'
	},
	SEND_NOTIFICATION_TO_REORG: {
		FAILURE : 'SEND_NOTIFICATION_TO_REORG_FAILURE',
		REQUEST : 'SEND_NOTIFICATION_TO_REORG_REQUEST',
		SUCCESS : 'SEND_NOTIFICATION_TO_REORG_SUCCESS'
	},
	DownloadFileWithMaterials: {
		FAILURE : 'DOWNLOAD_ORG_WITH_MATERIALS_FILE_FAILURE',
		REQUEST : 'DOWNLOAD_ORG_WITH_MATERIALS_FILE_REQUEST',
		SUCCESS : 'DOWNLOAD_ORG_WITH_MATERIALS_FILE_SUCCESS'
	}
}

export default checkPricesConstants